import Sticker from '@/components/symbol/sticker/sticker';
import useStickers from '../hooks/use-stickers';
import SymbolBlock from '../symbol-block';

const StickerBlocks = () => {
  const { stickers } = useStickers();

  return stickers.map(({ slug, symbols }) => (
    <SymbolBlock
      key={slug}
      slug={slug}>
      <div className='grid grid-cols-5 sm:grid-cols-6 gap-2'>
        {symbols.map((props) => (
          <Sticker
            key={props.id}
            {...props}
          />
        ))}
      </div>
    </SymbolBlock>
  ));
};

export default StickerBlocks;
